import React, { useState, startTransition } from "react";
import { useNavigate } from "react-router-dom";
import AgraniFooter from "./AgraniFooter";
import { toast } from "react-toastify";
import { useUploadLeadsMutation } from "features/CrmDashboardComp/CmrApiSlice";

const ContactUs = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    subject: "",
    message: "",
  });

  const [uploadLeads] = useUploadLeadsMutation();
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      phone_number: formData.phone_number,
      email: formData.email,
      lead_source: "Agrani Website",
      lead_details: [
        {
          service_name: "Enquiry",
          service_details: {
            message: formData.message,
            subject: formData.subject,
          },
        },
      ],
    };

    const jsonPayload = JSON.stringify(payload);

    try {
      const response = await fetch(
        "https://vaaradhi-dev.agrani.tech/api/v1/crm/leads",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: jsonPayload,
        }
      );

      if (!response.ok) {
        throw new Error("Form Submission Failed. Please try again.");
      }

      toast.success("Form Submitted Successfully");
      setFormData({
        first_name: "",
        last_name: "",
        phone_number: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      toast.success("Form Submitted Successfully");
    } finally {
      setLoading(false);
    }
  };
  const handleClick = (event) => {
    startTransition(() => {
      navigate("/dashboard");
    });
  };

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg py-lg-0 fixed-top px-lg-5 `}
        style={{ backgroundColor: "#000000" }}
      >
        <a href="/" className="navbar-brand ms-4 ms-lg-0">
          <img
            className=""
            src="/assets/img/agrani-logo.png"
            alt="Capital for Farmers"
            style={{ height: "40px" }}
          />
        </a>
        <div className="d-lg-none d-md-none px-2">
          <div className="d-flex">
            <div className=" ms-2">
              <a
                className="btn btn-outline-primary py-2 px-3 fs-6 text-decoration-none sign-in"
                onClick={handleClick}
                style={{
                  borderRadius: "5px",
                }}
              >
                Sign In
              </a>
            </div>
            <div className=" ms-2">
              <a
                className="btn text-white py-2 px-3 fs-6 text-decoration-none bg-orange"
                href="https://onboarding.agrani.io"
              >
                Create Account
              </a>
            </div>
          </div>
        </div>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto p-4 p-lg-0 fs-6">
            <a href="/" className="nav-item nav-link  text-decoration-none">
              Home
            </a>
            <a
              href="/contact"
              className="nav-item nav-link active text-decoration-none"
            >
              Contact
            </a>
          </div>

          <div className="d-none d-lg-flex ms-2">
            <a
              className="btn btn-outline-primary py-2 px-3 fs-6 text-decoration-none sign-in"
              onClick={handleClick}
              style={{
                borderRadius: "5px",
              }}
            >
              Sign In
            </a>
          </div>
          <div className="d-none d-lg-flex ms-2">
            <a
              className="btn text-white py-2 px-3 fs-6 text-decoration-none bg-orange"
              href="https://onboarding.agrani.io"
            >
              Create Account
            </a>
          </div>
        </div>
      </nav>
      <section className="bg-white py-3 py-md-5 mt-5 fade-in">
        <div className="container mt-3">
          <div className="row gy-3 gy-md-4 gy-lg-0 align-items-md-center">
            <div className="col-12 col-lg-6">
              <div className="row justify-content-xl-center">
                <div className="col-12 col-xl-11 px-lg-0 px-md-0 px-3">
                  <h2 className="h1 mb-3">Get in touch</h2>
                  <p className=" fs-6 text-secondary mb-lg-5 mb-md-5 mb-4">
                    We're always on the lookout to work with new clients. If
                    you're interested in working with us, please get in touch in
                    one of the following ways.
                  </p>
                  {/* Contact Info Section */}
                  <div className="d-flex mb-lg-5 mb-md-5 mb-4">
                    <div className="me-4 text-primary">
                      <span className="mdi mdi-map-marker-radius text-primary fs-1"></span>
                    </div>
                    <div>
                      <h4 className="mb-2">Address</h4>
                      <address className="mb-0 text-secondary fs-6">
                        1601, 16th Floor, World Trade Tower , Sector 16, Noida,
                        Uttar Pradesh
                      </address>
                    </div>
                  </div>
                  <div className="row mb-lg-5 mb-md-5 mb-4">
                    <div className="col-12 col-sm-6">
                      <div className="d-flex mb-lg-5 mb-md-5 mb-4 mb-sm-0">
                        <div className="me-4 text-primary">
                          <span className="mdi mdi-phone text-primary fs-2"></span>
                        </div>
                        <div>
                          <h4 className="mb-2">Phone</h4>
                          <p className="mb-0">
                            <a
                              className="link-secondary text-decoration-none fs-6"
                              href="tel:+18001029232"
                            >
                              18001029232
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-6">
                      <div className="d-flex mb-0">
                        <div className="me-4 text-primary">
                          <span className="mdi mdi-email fs-2"></span>
                        </div>
                        <div>
                          <h4 className="mb-2">E-Mail</h4>
                          <p className="mb-0">
                            <a
                              className="link-secondary text-decoration-none fs-6"
                              href="mailto:info@leadsconnect.in"
                            >
                              info@leadsconnect.in
                            </a>
                          </p>
                          <p>
                            <a
                              className="link-secondary text-decoration-none fs-6"
                              href="mailto:info@agrani.io"
                            >
                              info@agrani.io
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Form Section */}
            <div className="col-12 col-lg-6">
              <div className="bg-white border rounded shadow-sm overflow-hidden">
                <form onSubmit={handleSubmit}>
                  <div className="row gy-2 gy-xl-3 p-4 p-xl-5">
                    <div className="col-lg-6">
                      <label htmlFor="fullname" className="form-label ">
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="first_name"
                        placeholder="Enter your first name"
                        value={formData.first_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-lg-6 ">
                      <label htmlFor="fullname" className="form-label ">
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="last_name"
                        placeholder="Enter your last name"
                        value={formData.last_name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label htmlFor="email" className="form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <span className="mdi mdi-email fs-6"></span>
                        </span>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          placeholder="Enter your email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <label htmlFor="phone" className="form-label ">
                        Phone Number
                      </label>
                      <div className="input-group ">
                        <span className="input-group-text">
                          <span className="mdi mdi-phone fs-6"></span>
                        </span>
                        <input
                          type="tel"
                          className="form-control "
                          id="phone"
                          name="phone_number"
                          placeholder="Enter your phone number"
                          value={formData.phone_number}
                          onChange={handleChange}
                          required
                          maxLength={10}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <label htmlFor="subject" className="form-label ">
                        Subject <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="subject"
                        name="subject"
                        placeholder="Enter the subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12">
                      <label htmlFor="message" className="form-label ">
                        Message <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        id="message"
                        name="message"
                        rows="3"
                        placeholder="Write your message here"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <div className="d-grid">
                        <button
                          className="btn btn-primary btn-lg"
                          type="submit"
                        >
                          Send Message
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AgraniFooter />
    </>
  );
};

export default ContactUs;
